import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Card,
  Col,
  ColorPicker,
  Descriptions,
  Row,
  Space,
  Tabs,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import { ReactComponent as UserSvg } from "../../../assets/images/description/User.svg";
import { ReactComponent as EmailSvg } from "../../../assets/images/description/Message.svg";
import { ReactComponent as CalenderSvg } from "../../../assets/images/description/calendar.svg";
import { ReactComponent as ThemeSvg } from "../../../assets/images/description/Color Palette.svg";
import { ReactComponent as SubscriptionSvg } from "../../../assets/images/description/Crown.svg";
import { useNavigate } from "react-router";
import Img1 from "../../../assets/images/img1.png";
import { ReactComponent as ChangePassSvg } from "../../../assets/images/lockWhite.svg";
import { useDispatch, useSelector } from "react-redux";
import ChangePasswordModal from "../../auth/change-password/ChangePasswordModal";
import dayjs from "dayjs";
import { getProfileData } from "../../../redux/action/profile/getProfileAction";
import { getUserAllocatedCategory } from "../../../redux/action/user-management/userManagementAction";
const { TabPane } = Tabs;

const ViewProfileDetails = () => {
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();
  const [changePassword, setChangePassword] = useState(false);
  const dispatch = useDispatch();

  const data = useSelector((store) => store.getProfileData?.data);
  const { isLoading } = useSelector((store) => store.getProfileData);

  useEffect(() => {
    dispatch(getProfileData());
    dispatch(getUserAllocatedCategory({page: 1, size: 500}));
  }, [dispatch]);

  const categoryData = useSelector(
    (store) => store.getAllocatedCategory?.data?.rows
  );
  

  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const basicInfo_details = [
    {
      key: "1",
      label: (
        <>
          <UserSvg /> Name
        </>
      ),
      children: data?.name_en ?? "N/A",
    },
    {
      key: "2",
      label: (
        <>
          <EmailSvg /> Email
        </>
      ),
      children: data?.email ?? "N/A",
    },
    {
      key: "1",
      label: (
        <>
          <UserSvg /> Contact Person
        </>
      ),
      children: data?.contact_person_en ?? "N/A",
    },
    {
      key: "3",
      label: (
        <>
          <UserSvg /> Mobile Number
        </>
      ),
      children: data?.mobile_no ?? "N/A",
    },
    {
      key: "3",
      label: (
        <>
          <UserSvg /> Total Users
        </>
      ),
      children: data?.total_user ?? "0",
    },
    {
      key: "4",
      label: (
        <>
          <CalenderSvg /> Date Added
        </>
      ),
      children: dayjs(data?.created_at).format("DD-MM-YYYY") ?? "N/A",
    },
    {
      key: "5",
      label: (
        <>
          <ThemeSvg /> Primary Color
        </>
      ),
      children: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ColorPicker value={data?.primary_color ?? "#000000"} disabled />
          <span>{data?.primary_color ?? "#000000"}</span>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <ThemeSvg /> Primary Text Color
        </>
      ),
      children: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ColorPicker value={data?.font_color ?? "#000000"} disabled />
          <span>{data?.font_color ?? "#000000"}</span>
        </div>
      ),
      // span: 2,
    },
    {
      key: "2",
      label: (
        <>
          <ThemeSvg /> Background Color
        </>
      ),
      children: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ColorPicker value={data?.bg_color ?? "#000000"} disabled />
          <span>{data?.bg_color ?? "#000000"}</span>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <ThemeSvg /> Secondary Text Color
        </>
      ),
      children: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ColorPicker value={data?.text_color ?? "#000000"} disabled />
          <span>{data?.text_color ?? "#000000"}</span>
        </div>
      ),
    },
    {
      key: "6",
      label: (
        <>
          <SubscriptionSvg /> Subscription Plan
        </>
      ),
      children: data?.subscription_name_en ?? "N/A",
    },
    {
      key: "7",
      label: (
        <>
          <CalenderSvg /> Subscription Duration
        </>
      ),
      children:
        `${dayjs(data?.subscription_start_date).format("DD-MM-YYYY")} - ${dayjs(
          data?.subscription_end_date
        ).format("DD-MM-YYYY")}` ?? "N/A",
    },
  ];
  return (
    <>
      <div className="viewTenant">
        <div className="tableHeading">View Profile Details</div>
        <Space>
          <Button
            type="primary"
            onClick={() => setChangePassword(true)}
            icon={<ChangePassSvg />}
          >
            Change Password
          </Button>{" "}
        </Space>
      </div>
      <Card loading={isLoading}>
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          type="card"
          tabBarStyle={{ color: "#45AE51", fontWeight: "bold" }}
          className="custom-tabs"
        >
          <TabPane tab="General Details" key="1">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={18}>
                <div className="customDescription">
                  <Descriptions
                    className="custom_descriptions"
                    layout="vertical"
                    items={basicInfo_details}
                    size="small"
                    column={{ xs: 1, sm: 2, md: 3 }}
                  />
                </div>
              </Col>
              <Col xs={24} md={6}>
                <Avatar
                  size={120}
                  src={
                    data?.logo
                      ? `${process.env.REACT_APP_API_IMG_URI}/${data?.logo}`
                      : undefined
                  }
                  icon={!data?.logo ? <UserOutlined /> : undefined}
                  alt="User Img"
                  style={{
                    backgroundColor: data?.logo ? "grey" : "#45AE51",
                    color: "#fff",
                    border: "2px solid #fff",
                    boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
                  }}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tab="Category Allocated" key="2">
            <div className="tabHeading">
              List of all podcast category allocated
            </div>
            <div className="categoryAllocatedList">
              <Row gutter={16}>
                {categoryData?.map((item) => {
                  return (
                    <Col xs={24} sm={6}>
                      <div className="categoryItem">
                        <div className="imgBx">
                          <img
                            src={
                              item?.image_url
                                ? `${process.env.REACT_APP_API_IMG_URI}/${item?.image_url}`
                                : undefined
                            }
                            alt={item?.image_url}
                          />
                        </div>
                        <span>{item?.name_en}</span>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </TabPane>
        </Tabs>
      </Card>
      <ChangePasswordModal
        open={changePassword}
        onClose={() => {
          setChangePassword(false);
        }}
        // onConfirm={handleConfirm}
      />
    </>
  );
};

export default ViewProfileDetails;
